<template>
  <div
    :class="{ embedded: embed }"
    ref="videoContainer"
    style="position: relative; width: 100%"
  >

    <video
           ref="shakaVideo"
           :poster="posterURL"
           controls autoplay>
    </video>
  </div>
</template>

<script>
import shaka from "shaka-player";
import mux  from "mux.js";
window.muxjs = mux; // magic to make Shaka see Mux

export default {
  name: "ShakaContainer",
  props: {
    id: String,
    item: Object,
    autoplay: Boolean,
    cta: Object,
    embed: Boolean,
  },
  data() {
    return {
    }
  },
  mounted() {
    const vm = this;
    // Create a Player instance.
    const video = vm.$refs.shakaVideo;
    const player = new shaka.Player(video);

    // Attach player to the window to make it easy to access in the JS console.
    window.player = player;
    window.player.configure({
      manifest: {
        hls: {
          useFullSegmentsForStartTime: true,
        },
      },
    })

    // Listen for error events.
    player.addEventListener('error', vm.onError.bind(vm));

    // Try to load a manifest.
    // This is an asynchronous process.
    try {
      player.load(this.item.links.master_playlist_url).then(() => {
        // This runs if the asynchronous load is successful.
        console.log('The video has now been loaded!');
      });
    } catch (e) {
      // onError is executed if the asynchronous load fails.
      vm.onError(e);
    }

  },
  computed: {
    posterURL: function() {
      return this.item?.links?.poster_url;
    }
  },
  methods: {
    onError: function(err) {
      console.warn(err);
    }
  }
};
</script>
